export const GET_NOTES_INIT = 'GET_NOTES_INIT'
export const GET_NOTES_SUCCESS = 'GET_NOTES_SUCCESS'
export const GET_NOTES_ERROR = 'GET_NOTES_ERROR'

